import { jsx as _jsx } from "react/jsx-runtime";
import { isAuthenticated, logout } from 'models/user';
import { useDispatch, useSelector } from 'react-redux';
import { LoggedUser } from './components';
import { HeaderContainer } from './styles';
const Header = () => {
    const dispatch = useDispatch();
    const authenticated = useSelector(isAuthenticated);
    const userInfo = useSelector((state) => state.user.info); // Adjust according to your actual user slice
    if (!authenticated) {
        return null;
    }
    return (_jsx(HeaderContainer, { component: "header", children: _jsx(LoggedUser, { onLogout: () => dispatch(logout()), userInfo: userInfo }) }));
};
export default Header;
